import type { InfraRecordMaintenanceV1 } from '@gk/contracts'
import type { OverlayRow } from './db.ts'
import type { Projector } from './projectors.ts'
import { localDate } from '../lib/time.ts'

/** M16-E (docs/M16.md rule 2): the projection of infra.record_maintenance@1, a field FACT. What was done on a valve, a drain or a head shows on this device at once,
 *  pending, in the feature's panel on the map, on the day typed (or, absent, the club's own day of the moment, as the server derives it), with the note trimmed
 *  and the job or workshop order when there was one, until the server's row replaces it. The id is the device's own (newId), so a retry duplicates nothing;
 *  whether the feature was retired before that day is the server's to say (INFRA_RETIRED then tells the person). Registered in projectors.ts under the M16b hook. */
export const infraRecordMaintenance: Projector = async (cmd, db) => {
  const p = cmd.payload as InfraRecordMaintenanceV1
  const tz = ((await db.site.get(cmd.site_id)) as { timezone?: string } | undefined)?.timezone ?? 'Europe/Paris'
  const row: OverlayRow = {
    key: `geo.infra_maintenance:${p.maintenance_id}`, table: 'geo.infra_maintenance', id: p.maintenance_id, command_id: cmd.command_id, op: 'insert',
    row: {
      id: p.maintenance_id, org_id: cmd.org_id, site_id: cmd.site_id, feature_id: p.feature_id, done_on: p.done_on ?? localDate(cmd.occurred_at, tz), kind: p.kind,
      note: p.note?.trim() || null, job_id: p.job_id ?? null, work_order_id: p.work_order_id ?? null, entered_at: cmd.occurred_at,
      actor_person_id: cmd.actor_person_id ?? null, _pending: true,
    },
  }
  return [row]
}
